import "aos/dist/aos.css";
import React from "react";
import {useGlobalNotificationMessage} from "../context/message";
import {Button, Modal} from "react-bootstrap";

export default function GlobalNotificationMessage( {className, ...rest} ){
  const { message, removeMessage } = useGlobalNotificationMessage();
  return (
    <>
      <Modal show={!!message} onHide={removeMessage} centered contentClassName={'shadow'} >
        <Modal.Header closeButton>
          { message?.title && <Modal.Title>{ message?.title }</Modal.Title>}
        </Modal.Header>
        <Modal.Body className="text-center">
          <section>
            { message?.status === "danger" && <p className="text-danger"><span style={{"fontSize":"50pt"}} className="mdi mdi-alert-circle text-large"></span></p>}
            <p>{ message?.message }</p>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={removeMessage}>
            Zatvoriť
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
